import { jsx as _jsx } from "react/jsx-runtime";
function Currency({ className, size = 24 }) {
    return (_jsx("svg", { className: className, height: size, width: size, fill: "none", stroke: "currentColor", viewBox: "0 0 24 24", children: _jsx("path", { strokeLinecap: "square", strokeMiterlimit: 10, strokeWidth: 2, d: "M12 1.917v20.166M16.583 5.583H9.708a3.208 3.208 0 000 6.417h4.584a3.208 3.208 0 110 6.417H6.5" }) }));
}
export default Currency;
